import * as React from 'react';
import {Helmet} from 'react-helmet';

import {colors} from 'shells/colors/colors';
import {headTitle} from 'shells/document/head-title';
import {PreAuthLayout} from 'shells/layout/pre-auth-layout';
import {Link} from 'shells/link/link';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

export function PausedPage() {
    return (
        <PreAuthLayout
            backgroundColor={colors.navyLt}
            imageLeft={<img alt='' src='/include/images/auth/expired.svg' />}
        >
            <Helmet>
                <title>{headTitle('Account paused')}</title>
            </Helmet>
            <div>
                <Header>We hope to see you soon</Header>
                <Subheader as='p'>
                    An administrator for your account has paused your subscription. Ready to pick
                    things up where you left off? Please have an administrator log in and restore
                    your account.
                </Subheader>
                <Subheader as='p'>
                    <Link href='https://support.nutshell.com/' variant='primary' size='big'>
                        Contact Nutshell support
                    </Link>{' '}
                    with any questions.
                </Subheader>
            </div>
        </PreAuthLayout>
    );
}
